import { Flex, Spin } from 'antd'
import { useSearchParams } from 'react-router-dom'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { useBoosterProgramDraftFormValues } from 'hooks/booster-program'
import { BoosterProgramCreateForm } from 'modules/booster-program/form-create'

import '../styles.scss'

const BoosterProgramCreate = () => {
  const [searchParams] = useSearchParams()
  const draftId = searchParams.get('id') ?? undefined
  const isEditingDraft = !!draftId

  const { initialValues, isLoading } = useBoosterProgramDraftFormValues(draftId)

  const breadCrumbItems = [BREADCRUMBS.BOOSTER_PROGRAM, BREADCRUMBS.BOOSTER_PROGRAM_CREATE]

  return (
    <Flex vertical gap={24} className="booster-program">
      <Breadcrumb additionalItems={breadCrumbItems} />

      <div>
        <div className="main-title" style={{ marginBottom: 8 }}>
          {isEditingDraft ? 'Edit Booster Program' : 'Create Booster Program'}
        </div>
        <div className="main-description">
          {isEditingDraft
            ? 'Continue editing this draft booster program'
            : 'Create new booster program with milestone rewards'}
        </div>
      </div>

      {isLoading ? (
        <Flex justify="center" align="center" style={{ minHeight: 240 }}>
          <Spin />
        </Flex>
      ) : (
        <BoosterProgramCreateForm
          key={draftId ?? 'create'}
          draftId={draftId}
          initialValues={initialValues}
        />
      )}
    </Flex>
  )
}

export default BoosterProgramCreate
